import { render, staticRenderFns } from "./createPaxelMarketPartners.vue?vue&type=template&id=eb6a5ff4&"
import script from "./createPaxelMarketPartners.vue?vue&type=script&lang=js&"
export * from "./createPaxelMarketPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports